import React, { useEffect, useState } from "react";
import { Styles } from "./styles";
import SemiColumn from "../../../assets/images/backGrounds/semicolumn.svg";
import CoursesSectionBG from "../../../assets/images/backGrounds/coursesSectionBG.webp";
import Tag from "../../../assets/images/backGrounds/tag.svg";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper";
import { Container } from "react-bootstrap";
import SecondaryButton from "../../common/buttons/secondaryButton/SecondaryButton";
import { useTranslation } from "react-i18next";
import { getAllCategory } from "../../../services/categories.service";
import Error from "../../common/error/Error";
import { useSelector } from "react-redux";
import Loader from "../../common/loader/Loader";
import { Fade } from "react-reveal";
import RubberBand from "react-reveal/RubberBand";
import { useNavigate } from "react-router-dom";
import { getFeaturesCourses } from "../../../services/courses.service";
import Course from "../../course/Course";

const CoursesList = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const [data, setData] = useState();
  const [isDataLoading, setIsDataLoading] = useState(false);
  // language data from store
  const Resource = useSelector((state) => state.translation.resource);

  // get data from api
  const getData = async () => {
    setIsDataLoading(true);
    const response = await getFeaturesCourses();
    if (response?.status === 200) {
      setData(response?.data?.data);
      setIsDataLoading(false);
    } else {
      setIsDataLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <Styles>
      {isDataLoading ? (
        <Loader />
      ) : (
        data?.length > 0 && (
          <section id="coursesSection">
            <Container>
              <Fade bottom>
                <h2 className="section-title">
                  {Resource?.courses_title
                    ? Resource?.courses_title
                    : t("home.courses.title")}
                </h2>
              </Fade>
              <img className="bg" src={CoursesSectionBG} alt="background" />
              <img src={SemiColumn} className="semi-column" alt="semi column" />
              {isDataLoading ? (
                <Loader />
              ) : data?.length > 0 ? (
                data?.length > 2 ? (
                  <Swiper
                    navigation={true}
                    modules={[Navigation]}
                    loop={true}
                    breakpoints={{
                      0: {
                        slidesPerView: 1,
                      },
                      768: {
                        slidesPerView: 2,
                      },
                      992: {
                        slidesPerView: 3,
                      },
                    }}
                  >
                    {" "}
                    {data?.map((item, idx) => {
                      return (
                        <SwiperSlide key={idx}>
                          <Course
                            courseImage={item?.image}
                            courseName={item?.localizedName}
                            coursePrice={item?.price}
                            currency={item?.currency}
                            courseDecription={item?.localizedDescription}
                            studentCount={item?.studentCount}
                            sessionsCount={item?.sessionsCount}
                            Type={item?.type}
                            slug={item?.id}
                            rate={item?.totalReviewPoints}
                            fullNameEn={item?.tutor?.fullNameEn}
                            fullNameAr={item?.tutor?.fullNameAr}
                            shareLink={"#"}
                          />
                        </SwiperSlide>
                      );
                    })}
                  </Swiper>
                ) : (
                  <div className="courses-container">
                    {data?.map((item, idx) => {
                      return (
                        <div className="course" key={idx}>
                          <Course
                            courseImage={item?.image}
                            courseName={item?.localizedName}
                            coursePrice={item?.price}
                            currency={item?.currency}
                            courseDecription={item?.localizedDescription}
                            studentCount={item?.studentCount}
                            sessionsCount={item?.sessionsCount}
                            Type={item?.type}
                            slug={item?.id}
                            rate={item?.totalReviewPoints}
                            fullNameEn={item?.tutor?.fullNameEn}
                            fullNameAr={item?.tutor?.fullNameAr}
                            shareLink={"#"}
                          />
                        </div>
                      );
                    })}
                  </div>
                )
              ) : (
                <Error
                  message={
                    Resource?.no_courses
                      ? Resource?.no_courses
                      : t("no_courses")
                  }
                />
              )}
              <RubberBand>
                <img src={Tag} className="tag" alt="tag" />
              </RubberBand>
            </Container>
          </section>
        )
      )}
    </Styles>
  );
};

export default CoursesList;
